import React from 'react';
import { Box, TableSortLabel, Typography } from '@mui/material';
import { colors } from '@src/styles';
import { TTaskItem } from '../hooks/dto/taskItem.dto';

type Order = 'asc' | 'desc';

interface TaskListHeaderProps {
  order: Order;
  orderBy: keyof TTaskItem;
  handleSort: (property: keyof TTaskItem) => void;
}

export const TaskListHeader: React.FC<TaskListHeaderProps> = ({ order, orderBy, handleSort }) => {
  return (
    <Box
      sx={{
        padding: '6px 16px',
        backgroundColor: colors.background.primary,
        borderRadius: '4px 4px 0 0',
        borderBottom: `1px solid ${colors.brand.line}`,
        '& .MuiTypography-root, & .MuiTableSortLabel-root': {
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: '10px',
          fontWeight: 500,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
        },
        '& .MuiTypography-root': { color: colors.brand.textMuted },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1 }}>
        <Box sx={{ width: '200px' }}>
          <Typography variant="subtitle2" sx={{ color: colors.primary.white, fontWeight: 600 }}>
            Organização
          </Typography>
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle2" sx={{ color: colors.primary.white, fontWeight: 600 }}>
            Nome
          </Typography>
        </Box>
        <Box sx={{ width: '80px' }}>
          <Typography variant="subtitle2" sx={{ color: colors.primary.white, fontWeight: 600 }}>
            Status
          </Typography>
        </Box>
        <Box sx={{ width: '140px' }}>
          <TableSortLabel
            active={orderBy === 'createdAt'}
            direction={orderBy === 'createdAt' ? order : 'asc'}
            onClick={() => handleSort('createdAt')}
            sx={{
              color: colors.primary.white,
              '&.Mui-active': {
                color: colors.primary.yellow,
              },
              '& .MuiTableSortLabel-icon': {
                color: `${colors.primary.yellow} !important`,
              },
              '&:hover': {
                color: colors.primary.yellow,
              },
            }}
          >
            <Typography variant="subtitle2" sx={{ color: 'inherit', fontWeight: 600 }}>
              Data
            </Typography>
          </TableSortLabel>
        </Box>
        <Box sx={{ width: '120px' }}>
          <Typography variant="subtitle2" sx={{ color: colors.primary.white, fontWeight: 600 }}>
            Fonte
          </Typography>
        </Box>
        <Box sx={{ width: '100px' }}>
          <Typography variant="subtitle2" sx={{ color: colors.primary.white, fontWeight: 600 }}>
            Tipo
          </Typography>
        </Box>
        <Box sx={{ width: '158px' }}>
          <Typography variant="subtitle2" sx={{ color: colors.primary.white, fontWeight: 600 }}>
            Responsável
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
